import SAApi from './_saApi';
import httpClient from '@/apis/base/httpclient';

class sAReceiptAPI extends SAApi {
  constructor() {
    super();
  }
  controllerName = 'SAReceipts';

  /**
 * Lấy ra danh sách biên lai có thể lập chứng từ
 * @param {*} payload
 * @returns
 * * NNLINH 07.04.2023
 */
  async getDataReceipt(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataReceipt',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
* Lấy ra dữ liệu sinh chứng từ từ biên lai.
* @param {*} payload
* @returns
* * NNLINH 07.04.2023
*/
  async getDataGenerateReceipt(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataGenerateReceipt',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
}

export default new sAReceiptAPI();
